<div class="example-container">
  <table mat-table matSort [dataSource]="filteredDataSource$ | async">
    <!-- Name Column -->
    <ng-container matColumnDef="first_name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="user.first_name">
        {{ 'users_list.table.first_name' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.user?.first_name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="last_name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="user.last_name">
        {{ 'users_list.table.last_name' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.user?.last_name }}
      </td>
    </ng-container>

    <!-- Weight Column -->
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="user.email">
        {{ 'users_list.table.email' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element?.user?.email }}</td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="objective">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'users_list.table.target_score' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.objective | score }}
      </td>
    </ng-container>

    <ng-container matColumnDef="is_manager">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'users_list.table.administrator' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{
          (element?.is_manager
            ? 'manual_correction.yes'
            : 'manual_correction.no'
          ) | translate
        }}
      </td>
    </ng-container>

    <ng-container matColumnDef="estimated_scores">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header="estimated_scores[0].score"
      >
        {{ 'users_list.table.estimated_score' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.estimated_scores.length">
          {{ (element?.estimated_scores)[0].score | score }}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="manual_estimated_scores">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header="manual_estimated_scores[0].score"
      >
        D. test de posit.
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.manual_estimated_scores.length">
          {{ (element?.manual_estimated_scores)[0].score | score }}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="level">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="level">
        {{ 'users_list.table.level' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container>
          {{ element?.level }}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="time_spent">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'users_list.table.timing_usage' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.time_spent | parseDuration }}
      </td>
    </ng-container>

    <ng-container matColumnDef="training_active_time_seconds">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'users_list.table.timing_training' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.training_active_time_seconds | parseDuration }}
      </td>
    </ng-container>

    <ng-container matColumnDef="expiration_date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'users_list.table.expiration_date' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.expiration_date | amDateFormat: 'll' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions" stickyEnd>
      <th mat-header-cell *matHeaderCellDef>
        {{ 'users_list.table.actions' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <mat-button>
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button
              *ngFor="let action of actions; let i = index"
              (click)="action.click(element, i)"
              mat-menu-item
              type="button"
            >
              <mat-icon>{{ action.icon }}</mat-icon>
              <span>{{ action.text | translate }}</span>
            </button>
            <button
              *ngFor="
                let action of getUserActions(element);
                let i = index;
                trackBy: identify
              "
              (click)="action.click(element, i)"
              mat-menu-item
              type="button"
            >
              <mat-icon>{{ action.icon }}</mat-icon>
              <span>{{ action.text | translate }}</span>
            </button>
          </mat-menu>
        </mat-button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    [pageSizeOptions]="[25, 100, 200]"
    showFirstLastButtons
  ></mat-paginator>
</div>
